import apiClient from "./axiosInstanceStock";

// Adding the owner-related function
export const addItemToBookmark = async (bookmarkData) => {
  try {
    return await apiClient.post("/addBookmark", bookmarkData);
  } catch (error) {
    console.error("Error adding item to bookmark:", error);
    throw error; // Rethrow the error for further handling if needed
  }
};

export const getBookmark = async (userId, itemId) => {
  return await apiClient.get(`/getBookmark/${userId}/${itemId}`);
};

export const getAllBookmark = async (userId) => {
  return await apiClient.get(`/getAllBookmark/${userId}`);
};

export const BookmarkDelete = async (id) => {
  return await apiClient.delete(`/BookmarkDelete/${id}`);
};
